import React from 'react';
import { Box, Typography, Grid, useTheme, useMediaQuery } from '@mui/material';

const HereToHelp = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Box pt={'4rem'} textAlign={'center'}>
            <Grid container spacing={5} py={'3rem'}>
                <Grid
                    item
                    xs={12}
                    md={4}
                    textAlign={isMobile ? 'center' : 'right'}
                >
                    <img
                        src="\images\standing_chair.jpeg"
                        alt="Nick Schader - Relationship Coach"
                        style={{
                            maxWidth: '100%',
                            height: 'auto',
                            padding: 0,
                            margin: 0,
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={5} py={2} textAlign={'left'} mx={3}>
                    <Typography variant="h3">I'm Here to Help</Typography>
                    <Typography variant="h5">
                        Nick Schader - Relationship Coach For Christian Men
                    </Typography>
                    <Typography variant="body1" pt={1}>
                        Creating the relationship God intended for you is hard.
                        In fact, I believe it's the hardest thing you'll ever
                        do. And that's because it requires you to overcome your
                        fears and insecurities and become a better version of
                        yourself.
                        <br />
                        <br />
                        About 10 years into my marriage I almost lost
                        everything. I let my wife make all the decisions because
                        I thought that if she got her way, she'd be happy. I
                        avoided conflict, which meant that we never resolved
                        anything. I stopped loving her the way she needed to be
                        loved. I wasn't the man she needed.
                        <br />
                        <br />
                        Then one day she told me the fire had gone out and that
                        she wasn't sure she wanted to do it anymore. That caught
                        be by surprise. I knew things weren't great, but I
                        didn't think they were that bad. After all, I worked
                        hard to ensure we had a roof over our heads and food on
                        the table. What more did she want?
                        <br />
                        <br />
                        It took me way too long to figure out that if I wanted a
                        better marriage I had to become a better man. I had to
                        learn how to fulfill my responsibilities to love, lead,
                        provide, and protect. I had to learn how to resolve
                        conflict and meet her emotional needs. I had to learn to
                        become the man God created me to be.
                        <br />
                        <br />I don't want you to struggle any more. I don't
                        want you to waste any more time. I don't want you to
                        lose the love of your life. That's why I coach men who
                        are struggling in their relationship to become the man
                        their wife needs them to be and build a relationship
                        that will last. I use a 3-step process to guide them
                        through:
                        <li>
                            Eliminating FEARS and INSECURITIES so they can be
                            the man she needs
                        </li>
                        <li>
                            Fixing the COMMUNICATION so they can actually
                            resolve issues
                        </li>
                        <li>
                            Meeting each other's NEEDS so they can build a
                            relationship that will last
                        </li>
                        <br />
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    );
};

export default HereToHelp;
